import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'createCustomMethod';

const reducersKeys = {
  createRequest: 'createRequest',
  createSuccess: 'createSuccess',
  createFailure: 'createFailure',
};

const initialState = {
  created: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.createRequest]: (state) => {
      state.loading = true;
      state.created = false;
    },
    [reducersKeys.createSuccess]: (state) => {
      state.loading = false;
      state.created = true;
    },
    [reducersKeys.createFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const labelCreateReducer = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
